/**
 * Absolute URL of a build chunk, resolved against the URL docbox.js was loaded from. Chunks sit
 * next to docbox.js wherever it is hosted, so the host page's own URL is no help here. The
 * query string of the script URL (a cache-buster, for example) does not carry over.
 */
export function chunkUrl(scriptSrc: string, chunkPath: string): string {
  return new URL(chunkPath, scriptSrc).href;
}

type ScriptLookup = Pick<
  Document,
  "currentScript" | "querySelector" | "baseURI"
>;

/**
 * The <script> tag that loaded docbox.js. `document.currentScript` is set while a classic script
 * runs, including with `defer` and `async`. The selector fallback covers a host that loads the
 * script some other way (a tag manager that injects it with a wrapper).
 */
export function findScript(doc: ScriptLookup): HTMLScriptElement | null {
  const current = doc.currentScript as HTMLScriptElement | null;
  if (current?.src) return current;
  return doc.querySelector<HTMLScriptElement>('script[src*="docbox"]');
}

/**
 * The URL docbox.js was loaded from. With no script tag found, the page's own URL: the viewer
 * chunk then fails to load, and a document link click falls back to normal navigation.
 */
export function findScriptSrc(doc: ScriptLookup): string {
  return findScript(doc)?.src ?? doc.baseURI;
}
